import { motion } from 'framer-motion';
import React from 'react';
// import { NavLink } from 'react-router-dom'
import styled from 'styled-components';
import { Facebook, Github, Twitter, YouTube } from '../components/AllSvgs';
import { DarkTheme } from '../components/Themes';

const Icons = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	position: fixed;
	bottom: 0;
	left: 2rem;

	z-index: 3;

	& > *:not(:last-child) {
		margin: 0.5rem 0;
	}
`;

const Line = styled(motion.span)`
	width: 2px;
	height: 8rem;
	background-color: ${(props) =>
		props.color === 'dark' ? DarkTheme.text : DarkTheme.body};
`;

const SocialIcons = (props) => {
	return (
		<Icons>
			<motion.div
				initial={{ scale: 0 }}
				animate={{ scale: [0, 1, 1.5, 1] }}
				transition={{ type: 'spring', duration: 1, delay: 1.2 }}
			>
				<a
					style={{ color: 'inherit' }}
					target="_blank"
					href={'https://github.com/jake8989'}
				>
					<img src="/github.svg" height={30} width={30} alt="" />
				</a>
			</motion.div>
			<motion.div
				initial={{ scale: 0 }}
				animate={{ scale: [0, 1, 1.5, 1] }}
				transition={{ type: 'spring', duration: 1, delay: 1.2 }}
			>
				<a
					style={{ color: 'inherit' }}
					target="_blank"
					href={'https://leetcode.com/Jayantd13/'}
				>
					<img src="/leet.png" height={30} width={30} alt="" />
				</a>
			</motion.div>
			<motion.div
				initial={{ scale: 0 }}
				animate={{ scale: [0, 1, 1.5, 1] }}
				transition={{ type: 'spring', duration: 1, delay: 1.2 }}
			>
				<a
					style={{ color: 'inherit' }}
					target="_blank"
					href={'https://codeforces.com/profile/Jayantd13/'}
				>
					<img src="/cf.png" height={30} width={30} alt="" />
				</a>
			</motion.div>
			<motion.div
				initial={{ scale: 0 }}
				animate={{ scale: [0, 1, 1.5, 1] }}
				transition={{ type: 'spring', duration: 1, delay: 1.2 }}
			>
				<a
					style={{ color: 'inherit' }}
					target="_blank"
					href={'https://www.linkedin.com/in/jayant-dhakad-8a5517233/'}
				>
					<img src="/linkdin.svg" height={30} width={30} alt="" />
				</a>
			</motion.div>
			<motion.div
				initial={{ scale: 0 }}
				animate={{ scale: [0, 1, 1.5, 1] }}
				transition={{ type: 'spring', duration: 1, delay: 1.2 }}
			>
				<a
					style={{ color: 'inherit' }}
					target="_blank"
					href={'https://www.instagram.com/dhakad.jayant1/'}
				>
					<img src="/inst.svg" height={30} width={30} alt="" />
				</a>
			</motion.div>

			<Line
				color={props.theme}
				initial={{
					height: 0,
				}}
				animate={{
					height: '8rem',
				}}
				transition={{
					type: 'spring',
					duration: 1,
					delay: 0.8,
				}}
			/>
		</Icons>
	);
};

export default SocialIcons;
